<div class="h-full flex flex-col gap-6">
	<ui-button
		icon="arrow-back-up"
		label="Back to LEAP page"
		[preset]="BUTTON_PRESETS.EXTRA_LOW_EMPHASIS"
		(click)="backToLeapIntegrationPage()"
	></ui-button>

	<atomic-button-group
		[ngModel]="currSelectedPage$ | async"
		[options]="mergeReviewSelectionOptions$ | async"
		(onClick)="onPageSelectionChange($event)"
	></atomic-button-group>

	<div class="flex-grow">
		<div
			class="h-full flex flex-col gap-6 overflow-y-auto"
			[ngClass]="{
				hidden:
					(currSelectedPage$ | async) !==
					ClientsMergeReviewPage.CLIENTS_MERGE_REPORT,
			}"
		>
			<table mat-table [dataSource]="mergedClientsDataSource$ | async">
				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef>Client Name</th>
					<td mat-cell *matCellDef="let client" class="break-all">
						{{ client.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef>Email</th>
					<td mat-cell *matCellDef="let client" class="break-all">
						{{ client.email }}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="mergedClientsTableColumns"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: mergedClientsTableColumns"
				></tr>
			</table>
		</div>

		<div
			class="h-full flex flex-col gap-6"
			[ngClass]="{
				hidden:
					(currSelectedPage$ | async) !==
					ClientsMergeReviewPage.FIX_CLIENTS_LIST,
			}"
		>
			<div class="flex flex-col gap-2 p-5 border border-gray-200 rounded-lg">
				<div class="flex items-center gap-2 text-base">
					<i-tabler name="info-circle" class="text-gray-500 h-4 w-4"></i-tabler>
					<span class="text-gray-950 font-medium"
						>Select LEAP clients to correspond with your Closer clients</span
					>
				</div>

				<div class="text-sm">
					Please match your LEAP clients to the correct Closer client profiles
					in bold below to ensure that your client list is matching.
				</div>
			</div>

			<div class="flex-grow">
				<div class="client-conflict-table border border-gray-200 rounded-lg">
					<!-- Header Begins -->
					<div
						class="py-4 px-5 font-bold text-base text-gray-950 bg-grey-veryLight rounded-tl-lg"
					>
						Client Name
					</div>
					<div
						class="py-4 px-5 font-bold text-base text-gray-950 bg-grey-veryLight"
					>
						Source
					</div>
					<div
						class="py-4 px-5 font-bold text-base text-gray-950 bg-grey-veryLight"
					>
						Birthdate
					</div>
					<div
						class="py-4 px-5 font-bold text-base text-gray-950 bg-grey-veryLight"
					>
						Email
					</div>
					<div
						class="py-4 px-5 font-bold text-base text-gray-950 bg-grey-veryLight"
					>
						Last Active File Date
					</div>
					<div
						class="py-4 px-5 font-bold text-base text-gray-950 bg-grey-veryLight rounded-tr-lg"
					></div>
					<!-- Header Ends -->

					<!-- Body Begins -->
					<ng-container
						*ngFor="
							let unmergedClient of unmergedClientsData$ | async;
							let isLast = last
						"
					>
						<div
							class="py-4 px-5 bg-white border-b border-b-gray-200 flex items-center border-t-2 border-t-gray-200 font-semibold"
						>
							{{ unmergedClient.name }}
						</div>
						<div
							class="py-4 px-5 bg-white border-b border-b-gray-200 flex items-center border-t-2 border-t-gray-200 font-semibold"
						>
							<div class="h-4">
								<img
									class="h-full w-auto"
									src="/assets/images/closer-icon-green.svg"
									alt="Closer logo"
								/>
							</div>
						</div>
						<div
							class="py-4 px-5 bg-white border-b border-b-gray-200 flex items-center border-t-2 border-t-gray-200 font-semibold"
						>
							{{ unmergedClient.birthDate }}
						</div>
						<div
							class="py-4 px-5 bg-white border-b border-b-gray-200 flex items-center border-t-2 border-t-gray-200 font-semibold"
						>
							{{ unmergedClient.email }}
						</div>
						<div
							class="py-4 px-5 bg-white border-b border-b-gray-200 flex items-center border-t-2 border-t-gray-200 font-semibold"
						>
							{{ unmergedClient.lastActiveFileDate }}
						</div>
						<div
							class="py-4 px-5 bg-white border-b border-b-gray-200 flex justify-center items-center border-t-2 border-t-gray-200 font-semibold"
						>
							<div class="h-full">
								<ui-button
									icon="x"
									class="text-gray-500 h-4 w-4"
									[preset]="BUTTON_PRESETS.ICON_DEFAULT"
									(click)="removeUnmergedClient(unmergedClient.closerClientId)"
									[disabled]="clientExportInProgress$ | async"
								></ui-button>
							</div>
						</div>

						<ng-container
							*ngFor="let leapMatches of unmergedClient.leapMatches"
						>
							<div class="py-4 px-5 bg-white">
								<app-radio
									alignContents="left"
									[ngModel]="
										(unmergedClientsRadioValuesModel$ | async)[
											unmergedClient.closerClientId
										]
									"
									[label]="leapMatches.name"
									[value]="leapMatches.radioValue"
									[type]="'default'"
									(ngModelChange)="
										unmergedClientRadioHandler(
											$event,
											unmergedClient.closerClientId
										)
									"
									[disabled]="clientExportInProgress$ | async"
								></app-radio>
							</div>
							<div class="py-4 px-5 bg-white flex items-center">
								<div class="h-4">
									<img
										class="h-full w-auto rounded"
										src="/assets/images/leap/leap-logo.png"
										alt="Leap logo"
									/>
								</div>
							</div>
							<div class="py-4 px-5 bg-white flex items-center">
								{{ leapMatches.birthDate }}
							</div>
							<div class="py-4 px-5 bg-white flex items-center">
								{{ leapMatches.email }}
							</div>
							<div class="py-4 px-5 bg-white"></div>
							<div class="py-4 px-5 bg-white"></div>
						</ng-container>

						<div
							class="py-4 px-5 bg-white"
							[ngClass]="{ 'rounded-bl-lg': isLast }"
						>
							<app-radio
								alignContents="left"
								[ngModel]="
									(unmergedClientsRadioValuesModel$ | async)[
										unmergedClient.closerClientId
									]
								"
								label="Create as new client"
								[value]="PresetRadioValue.CREATE_AS_NEW_CLIENT"
								type="default"
								(ngModelChange)="
									unmergedClientRadioHandler(
										$event,
										unmergedClient.closerClientId
									)
								"
								[disabled]="clientExportInProgress$ | async"
							></app-radio>
						</div>
						<div class="py-4 px-5 bg-white flex items-center">
							<div class="h-4">
								<img
									class="h-full w-auto rounded"
									src="/assets/images/leap/leap-logo.png"
									alt="Leap logo"
								/>
							</div>
						</div>
						<div class="py-4 px-5 bg-white"></div>
						<div class="py-4 px-5 bg-white"></div>
						<div class="py-4 px-5 bg-white"></div>
						<div
							class="py-4 px-5 bg-white"
							[ngClass]="{ 'rounded-br-lg': isLast }"
						></div>
					</ng-container>
					<!-- Body ends -->
				</div>
			</div>

			<div class="flex justify-end gap-4 pb-10">
				<div
					class="flex items-center gap-2"
					*ngIf="clientExportInProgress$ | async"
				>
					<i-tabler name="progress"></i-tabler>
					<span
						*ngIf="
							resolvedUnmergedClientsTracker$ | async as resolvedUnmergedClients
						"
						>{{ resolvedUnmergedClients.mergedClients }}/{{
							resolvedUnmergedClients.totalResolvedClients
						}}
						clients merged</span
					>
				</div>

				<ui-button
					label="Confirm and Merge Selected ({{
						mergeableClientsCount$ | async
					}})"
					color="primary"
					(click)="exportUnmergedClientsToLeap()"
					[loading]="clientExportInProgress$ | async"
					[disabled]="
						(clientExportInProgress$ | async) ||
						(mergeableClientsCount$ | async) === 0
					"
				></ui-button>
			</div>
		</div>
	</div>
</div>
